import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-swiper-ways-study',
  templateUrl: './swiper-ways-study.component.html',
  styleUrls: ['./swiper-ways-study.component.scss']
})
export class SwiperWaysStudyComponent implements OnInit {

  waySwiperInstance: any;
  wayIndex: number = 0;

  // A swiper config which is responsive and doesn't show partial slides and only shows 1 slide (typically used for quotes)

  public standardConfig: any = {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true, // Automatically hides pagination when not needed
    pagination: { clickable: true },
    autoplay: { delay: 5000 },
    loop: true,
    breakpoints: {
      768: {
        pagination: false
      },
    }
  };

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  /**
     * When 'Ways you can study' swiper is ready then issue update so that the sizing is correct
     * @param swiper 
     */
  onWaySwiper(swiper) {

    this.waySwiperInstance = swiper;

    setTimeout(() => {
      // swiper.update();
    }, 1500);

  }

  /**
   * Using slidechange to disable / enable the next and previous buttons
   */
  onWaySlideChange() {

    if (this.waySwiperInstance) {
      this.wayIndex = this.waySwiperInstance.realIndex;
      this.cd.detectChanges();
    }

  }

  /**
   * Slides to the next image
   */
  gotoWay(index: number) {

    this.waySwiperInstance.slideTo(index);

  }

}
